import { withPopup } from '../buttons';

export const OptionsCellItems = withPopup((props) => {
  const { popupDisplayHandler, disabled } = props;

  /**
   * on cell click
   * @param {*} event
   */
  const onClick = (event) => {
    event.stopPropagation();
    popupDisplayHandler(event);
  };

  return <img onClick={disabled ? null : onClick} src="/images/grid-options.png" alt="..." style={{ cursor: 'pointer' }} />;
});
